interface SupplyAddress {
  buildingName?: string | null;
  buildingNumber?: string | null;
  dependentLocality?: string | null;
  dependentThoroughfare?: string | null;
  doubleDependentLocality?: string | null;
  subBuilding?: string | null;
  thoroughfare?: string | null;
}

/*
  logic here derived from
  https://github.com/utilitywarehouse/telecom-fixed-line/blob/main/pkg/address/addressots.go#L29

  and converted to TS from
  https://github.com/utilitywarehouse/uw-jtc-app/blob/f3d443ad726e8a5fb018e2d4abf63bec761b06c0/app/components/modules/YourDetails/OneTouchSwitchSection/formatAddress.js
*/
const formatAddressLines = (address?: SupplyAddress) => {
  if (!address) return [];
  const addressLines: (string | null | undefined)[] = [address.subBuilding];

  if (address.buildingName && /^\d/.test(address.buildingName)) {
    const line = [];

    line.push(address.buildingName);

    if (address.dependentThoroughfare) {
      line.push(address.dependentThoroughfare);
    } else if (address.thoroughfare) {
      line.push(address.thoroughfare);
    }

    addressLines.push(line.join(' '));
  } else {
    addressLines.push(address.buildingName);
    const line = [];

    if (address.buildingNumber) {
      line.push(address.buildingNumber);
    }
    if (address.dependentThoroughfare) {
      line.push(address.dependentThoroughfare);
    } else if (address.thoroughfare) {
      line.push(address.thoroughfare);
    }

    addressLines.push(line.join(' '));
  }

  addressLines.push(address.doubleDependentLocality);
  addressLines.push(address.dependentLocality);

  return addressLines.filter(Boolean) as string[];
};

export { formatAddressLines };
